import React from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";
import IconCircle from "../../shared/IconCircle";
import { cardDescSx, cardTitleSx, COLORS, CONTENT_MAX_WIDTH } from "../../shared/styles";
import { ReactComponent as DropdownIcon } from "../../../../../assets/images/dropdown-arrow.svg";
import {
  peopleScrollSelectMenuProps,
  peopleSelectControlSx,
  peopleSelectSx,
} from "../../../People/peopleSelectStyles";
import { CheckCircleIcon } from "./icons";
import RoutingRadio from "./RoutingRadio";

const TEAM_SELECT_WIDTH = 536;

const menuItemSx = {
  fontFamily: "Inter",
  fontSize: 14,
};

function TicketRoutingOptionCard({
  option,
  selected,
  onSelect,
  teams = [],
  teamId,
  onTeamChange,
  teamsLoading,
}) {
  const selectMenuProps = peopleScrollSelectMenuProps();
  const minHeight = selected ? option.minHeightSelected : option.minHeight;

  return (
    <Box
      onClick={onSelect}
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect();
        }
      }}
      sx={{
        width: "100%",
        maxWidth: CONTENT_MAX_WIDTH,
        minHeight,
        p: "16px",
        borderRadius: "8px",
        border: `1px solid ${selected ? COLORS.primary : COLORS.border}`,
        bgcolor: selected ? "#F3FBFF" : COLORS.white,
        boxShadow: selected ? "0 1px 2px 0 rgba(20, 141, 253, 0.10)" : "none",
        boxSizing: "border-box",
        display: "block",
        textAlign: "left",
        cursor: "pointer",
        outline: "none",
        "&:focus-visible": {
          outline: `2px solid ${COLORS.primary}`,
          outlineOffset: 2,
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
        <IconCircle bgcolor={selected ? "#D6EDFF" : COLORS.backgroundLight}>
          <CheckCircleIcon selected={selected} />
        </IconCircle>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography component="p" sx={cardTitleSx}>
                {option.title}
              </Typography>
              <Typography component="p" sx={{ ...cardDescSx, mt: "4px" }}>
                {option.description}
              </Typography>
            </Box>
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{ pt: "3px" }}
            >
              <RoutingRadio selected={selected} onClick={onSelect} />
            </Box>
          </Box>

          {option.showTeamSelect && selected ? (
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{ mt: "16px" }}
            >
              <TextField
                select
                fullWidth
                value={teamId || ""}
                onChange={(e) => onTeamChange(e.target.value)}
                disabled={teamsLoading || !teams.length}
                sx={{
                  ...peopleSelectControlSx({ maxWidth: TEAM_SELECT_WIDTH }),
                  maxWidth: TEAM_SELECT_WIDTH,
                }}
                SelectProps={{
                  displayEmpty: true,
                  IconComponent: DropdownIcon,
                  MenuProps: selectMenuProps,
                  sx: peopleSelectSx,
                  renderValue: (selectedValue) => {
                    if (!selectedValue) {
                      return <span style={{ color: "#9BA6B2" }}>Select team</span>;
                    }
                    const team = teams?.find((t) => t.id === selectedValue);
                    return team ? team.name : "";
                  },
                }}
              >
                {!teams.length ? (
                  <MenuItem value="" disabled sx={menuItemSx}>
                    {teamsLoading ? "Loading teams..." : "No teams available"}
                  </MenuItem>
                ) : (
                  teams.map((team) => (
                    <MenuItem key={team.id} value={team.id} sx={menuItemSx}>
                      {team.name}
                    </MenuItem>
                  ))
                )}
              </TextField>
         
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}

export default TicketRoutingOptionCard;
